import React, { useEffect } from 'react';

const Alert = ({type, msg, removeAlert}) => {

    useEffect (() => {
        const timeout = setTimeout(() => {
            removeAlert();
        }, 3000)
        return () => clearTimeout(timeout)
    }, [])
    return <p className={`${type}-alert`}>{msg}</p>
            {/* <p className='danger-alert'>The field can't be empty, enter a value</p> */}
            {/* <p className='success-alert'>Item has been added to the list</p> */}
            
};

export default Alert;